import { Button, Col, Container, FormGroup, Row } from "react-bootstrap"
import { Async, Operation, Variable } from "react-declarative-state"
import { useNavigate, useParams } from "react-router-dom"
import { Form as GoodForm } from "react-good-form"
import { resetPassword } from "../services/userService"
import { toast } from "../portals/toast"

const ResetPassword: React.FC = () => {
  const { token } = useParams()
  const navigate = useNavigate()
  return (
    <Container>
      <Row>
        <Col xs={12} md={{ span: 6, offset: 3 }}>
          <Variable
            initialValue={
              { newPassword: "", newPasswordAgain: "", passwordChanged: false } as {
                newPassword: string
                newPasswordAgain: string
                passwordChanged: boolean
              }
            }
          >
            {(passwordReset, setPasswordReset) =>
              passwordReset.passwordChanged ? (
                <>
                  <div className="d-flex flex-column">
                    <h3 className="mb-3">Salasana vaihdettu!</h3>
                    <Button onClick={() => navigate("/login")}>Siirry kirjautumaan</Button>
                  </div>
                </>
              ) : (
                <Operation
                  onDone={() => {
                    console.log("DONE")
                    setPasswordReset({ ...passwordReset, passwordChanged: true })
                  }}
                >
                  {(doOperation, progress) => (
                    <GoodForm
                      value={passwordReset}
                      onChange={setPasswordReset}
                      onSubmit={() => {
                        console.log("Submit")
                        doOperation(
                          resetPassword(passwordReset.newPassword, token || "").do(
                            () => {},
                            (err) => {
                              toast("Jokin meni pieleen. Yritä uudelleen.", "danger")
                            }
                          )
                        )
                      }}
                    >
                      {({ Input }) => (
                        <>
                          <div className="d-flex flex-column">
                            <h3 className="mb-3">Anna uusi salasana</h3>
                            <div className="mb-3"></div>
                            <FormGroup className="mb-4">
                              <Input
                                type="email"
                                for="newPassword"
                                placeholder="email@huolla.com"
                                required
                                className="form-control"
                              ></Input>
                            </FormGroup>
                            <div className="mb-4">
                              <Button
                                disabled={progress === Async.Progress.Progressing}
                                className="form-control"
                                type="submit"
                                variant="primary"
                              >
                                Lähetä linkki
                              </Button>
                            </div>
                          </div>
                        </>
                      )}
                    </GoodForm>
                  )}
                </Operation>
              )
            }
          </Variable>
        </Col>
      </Row>
    </Container>
  )
}

export default ResetPassword
